import React from 'react';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const AboutSection = () => {
  const {
    FaBuilding,
    FaArrowUpRightFromSquare,
    FaThreads,
    FaInstagram,
    FaFacebook
  } = Fa6Icons;

  const contactLinks = [
    {
      label: 'Threads',
      href: 'https://www.threads.com/@homy.hk',
      icon: FaThreads
    },
    {
      label: 'Instagram',
      href: 'https://www.instagram.com/homy.hk',
      icon: FaInstagram
    },
    {
      label: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=61578745554661',
      icon: FaFacebook
    }
  ];

  return (
    <section
      id="about"
      aria-labelledby="about-title"
      className="glass-card rounded-2xl shadow-xl p-6 md:p-8 mt-8 border border-white/40 dark:border-neutral-700/50 scroll-mt-24"
    >
      <div className="grid grid-cols-1 lg:grid-cols-[1.35fr_1fr] gap-8 items-start">
        <div>
          <div className="flex items-start gap-4">
            <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-2xl bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400">
              <SafeIcon icon={FaBuilding} className="text-xl" />
            </span>
            <div>
              <h2
                id="about-title"
                className="text-xl font-bold text-gray-900 dark:text-white"
              >
                誰在維護 Cheque Fill？
              </h2>
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                關於網站與內容負責人
              </p>
            </div>
          </div>

          <p className="mt-5 text-sm leading-7 text-gray-600 dark:text-gray-300">
            Cheque Fill 由 Homy Tech 開發及維護，旨在為香港用戶、財務人員與跨境商務團隊提供清晰、方便的支票金額及多語言文字轉換參考。所有金額轉換均直接在瀏覽器內完成，不會上傳或儲存輸入資料。
          </p>

          <a
            href="https://homy.hk/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-5 text-sm font-bold text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
          >
            瀏覽 Homy Tech 官方網站
            <SafeIcon icon={FaArrowUpRightFromSquare} className="text-xs" />
          </a>
        </div>

        <div className="rounded-2xl bg-gray-50/80 dark:bg-neutral-900/40 border border-gray-100 dark:border-neutral-700 p-5">
          <h3 className="text-base font-bold text-gray-800 dark:text-gray-100">
            如何聯絡 Homy Tech？
          </h3>
          <p className="mt-2 text-sm leading-6 text-gray-500 dark:text-gray-400">
            如要回報問題、提出合作或功能建議，可透過官方網站或以下社交平台聯絡我們。
          </p>

          <div className="flex flex-wrap gap-3 mt-5">
            {contactLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 text-sm font-semibold text-gray-700 dark:text-gray-200 hover:border-primary-300 hover:text-primary-600 dark:hover:border-primary-700 dark:hover:text-primary-400 hover:-translate-y-0.5 transition-all shadow-sm"
                aria-label={`透過 ${link.label} 聯絡 Homy Tech`}
              >
                <SafeIcon icon={link.icon} />
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      <p className="mt-7 pt-5 border-t border-gray-100 dark:border-neutral-700/60 text-xs text-gray-400 dark:text-gray-500">
        本頁資料最近更新：
        <time dateTime="2026-03-07">2026 年 3 月 7 日</time>
      </p>
    </section>
  );
};

export default AboutSection;